import { notifier } from '@cbgms/base/notifier/use-notifier'
import { i18next } from 'app-support/contexts/I18nContext'

import tokenExpired from './tokenExpired'
import validationError from './validationError'
import { retrieveError } from './utils'
import { IFailedRequest } from '../'

type Handler = (failedRequest: IFailedRequest) => any

interface IHandlers {
  [index: string]: Handler
}

const defaultHandler = ({ error }: any) => {
  const errorCode = retrieveError(error)

  if (i18next.exists(`Error.API.${errorCode}`)) {
    notifier.error(i18next.t(`Error.API.${errorCode}`))

    return
  }

  if (errorCode) {
    notifier.error(errorCode)
  } else {
    notifier.error(i18next.t('global.http_unknown_error'))
  }
}

// Handlers are triggered based on their Type. If no match could be found, default handler will run,
// Return value of handler determines if an error will be thrown.
const handlers: IHandlers = {
  ErrTokenExpired: tokenExpired,
  ErrNoAddressFound() {},
  ErrUserNotFound() {},
  ErrNoExternalGMSLinked() {
    return { Data: null }
  },
  ErrNoHaynesVoltCustomer() {
    return { Data: null }
  },
  CognitoAliasExistsException: defaultHandler,
  validationError,
  default: defaultHandler
}

export default handlers
